import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";

import { Modal } from "@lib/modal";
import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";
import { CashoutLocation } from "@utils/common/cashoutLocation";
import { OpenCashoutModalType } from "@data-types/my-bets/OpenCashoutModal";

export default observer(function CashoutMessageModal(props: {
	store: CashoutStore;
}) {
	const { t } = useTranslation();
	const methods = useForm();

	const { register, handleSubmit } = methods;

	const onSubmit = (data: OpenCashoutModalType) => {
		if (props.store.cashoutModalData) {
			props.store.cashout(
				{
					id: props.store.cashoutModalData?.id,
					calculatedCashoutAmount:
						props.store.cashoutModalData?.calculatedCashoutAmount,
					displayedAmount:
						props.store.cashoutModalData.displayedAmount,
					userId: props.store.cashoutModalData.userId,
					cType: props.store.cashoutModalData?.cType,
					isLive: props.store.cashoutModalData?.isLive,
					isChangeAccepted: data.isChangeAccepted || false,
					liveBetSlipCountdown:
						props.store.cashoutModalData?.liveBetSlipCountdown,
				},
				CashoutLocation.OFFER
			);
		}
	};

	return (
		<Modal>
			<FormProvider {...methods}>
				<form
					onSubmit={handleSubmit(onSubmit)}
					id="cashout-form"
					className="popup"
				>
					<div className="popup__card">
						<div className="popup__header">
							{t<string>("mybets:CASHOUT.TITLE")}
						</div>

						<div className="popup__body">
							<InfoMessageComponent
								type="warning"
								size="sml"
								message={props.store.cashoutModalData?.message}
							/>
							<div className="form__group u-mar--top--xsml">
								<div className="input--check">
									<input
										id="isChangeAccepted"
										className="input--check__box"
										type="checkbox"
										{...register("isChangeAccepted")}
										name="isChangeAccepted"
									/>
									<label
										htmlFor="isChangeAccepted"
										className="input--check__label"
									>
										{t<string>(
											"mybets:CASHOUT.ACCEPT_CHANGED_AMOUNT"
										)}
									</label>
								</div>
							</div>
						</div>

						<div className="popup__footer">
							<button
								id="close"
								className="at-cashoutModalSecondaryBtn popup__btn btn btn--base btn--primary--inverted"
								type="button"
								onClick={props.store.closeCashoutModal}
							>
								{t<string>("COMMON.CANCEL")}
							</button>
							<button
								className="at-cashoutModalPrimaryBtn popup__btn btn btn--base btn--cashout"
								type="submit"
							>
								{t<string>("mybets:CASHOUT.TITLE")}
							</button>
						</div>
					</div>
				</form>
			</FormProvider>
		</Modal>
	);
});
